<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary bg="/images/sub/story/visual.jpg">
                <template #title>{{ $t("고추장 이야기") }}</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <template #subtit>story</template>
            <template #tit>{{ $t("고추장 이야기") }}</template>

            <!-- S: 01 -->
            <div class="story">
                <v-row no-gutters justify="end" align="center">
                    <v-col cols="12" md="6">
                        <div class="story__txt">
                            <u-tit-wrap-default class="tit-wrap--sm">
                                <u-tit-subtit>01</u-tit-subtit>
                                <u-tit-default>{{ $t("story1.tit") }}</u-tit-default>
                            </u-tit-wrap-default>
                            <txt-primary class="grey--text text--darken-4">
                                <span v-html="$t('story1.txt')" />
                            </txt-primary>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <div class="story__bg story__bg--01" data-aos="fade-left" data-aos-delay="100" data-aos-offset="300">
                            <v-img eager src="/images/sub/story/story-01.jpg" class="d-xl-none" />
                        </div>
                    </v-col>
                </v-row>
            </div>
            <!-- E: 01 -->

            <!-- S: 02 -->
            <div class="story">
                <v-row no-gutters justify="end" align="center">
                    <v-col cols="12" md="6" order-md="2">
                        <div class="story__txt">
                            <u-tit-wrap-default class="tit-wrap--sm">
                                <u-tit-subtit>02</u-tit-subtit>
                                <u-tit-default>{{ $t("story2.tit") }}</u-tit-default>
                            </u-tit-wrap-default>
                            <txt-primary class="grey--text text--darken-4">
                                <span v-html="$t('story2.txt')" />
                            </txt-primary>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6" order-md="1">
                        <div class="story__bg story__bg--02" data-aos="fade-right" data-aos-delay="100">
                            <v-img eager src="/images/sub/story/story-02.jpg" class="d-xl-none" />
                        </div>
                    </v-col>
                </v-row>
            </div>
            <!-- E: 02 -->

            <!-- S: 03 -->
            <div class="story">
                <v-row no-gutters justify="end" align="center">
                    <v-col cols="12" md="6">
                        <div class="story__txt">
                            <u-tit-wrap-default class="tit-wrap--sm">
                                <u-tit-subtit>03</u-tit-subtit>
                                <u-tit-default>{{ $t("story3.tit") }}</u-tit-default>
                            </u-tit-wrap-default>
                            <txt-primary class="grey--text text--darken-4">
                                <span v-html="$t('story3.txt')" />
                            </txt-primary>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <div class="story__bg story__bg--03" data-aos="fade-left" data-aos-delay="100">
                            <v-img eager src="/images/sub/story/story-03.jpg" class="d-xl-none" />
                        </div>
                    </v-col>
                </v-row>
            </div>
            <!-- E: 03 -->

            <!-- S: 04 -->
            <div class="story">
                <v-row no-gutters justify="end" align="center">
                    <v-col cols="12" md="6" order-md="2">
                        <div class="story__txt">
                            <u-tit-wrap-default class="tit-wrap--sm">
                                <u-tit-subtit>04</u-tit-subtit>
                                <u-tit-default>{{ $t("story4.tit") }}</u-tit-default>
                            </u-tit-wrap-default>
                            <txt-primary class="grey--text text--darken-4">
                                <span v-html="$t('story4.txt')" />
                            </txt-primary>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6" order-md="1">
                        <div class="story__bg story__bg--04" data-aos="fade-right" data-aos-delay="100">
                            <v-img eager src="/images/sub/story/story-04.jpg" class="d-xl-none" />
                        </div>
                    </v-col>
                </v-row>
            </div>
            <!-- E: 04 -->
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import PageSectionSecondary from "@/sets/parents/pages/page-section-secondary.vue";
import BtnPrimary from "@/components/publish/parents/buttons/btn-primary.vue";

import UTitWrapDefault from "@/components/publish/styles/typography/u-tit-wrap-default.vue";
import UTitSubtit from "@/components/publish/styles/typography/u-tit-subtit.vue";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";
import TxtPrimary from "@/components/publish/parents/typography/txt-primary.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        PageSectionSecondary,
        BtnPrimary,
        UTitWrapDefault,
        UTitSubtit,
        UTitDefault,
        TxtPrimary,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.story {
    margin-bottom: 60px;
    &__txt {
        margin-bottom: 14px;
    }
    &:last-child {
        margin-bottom: 0;
    }
    &:nth-child(even) .story__bg .v-image {
        border-radius: var(--rounded-lg) 0 0 var(--rounded-lg);
    }
    &:nth-child(odd) .story__bg .v-image {
        border-radius: 0 var(--rounded-lg) var(--rounded-lg) 0;
    }
}
@media (min-width: 768px) {
    .story {
        margin-bottom: 80px;
        &__txt {
            margin-bottom: 0;
        }
        &:nth-child(even) .story__txt {
            padding-right: 40px;
        }
        &:nth-child(odd) .story__txt {
            padding-left: 40px;
        }
    }
}
@media (min-width: 1024px) {
    .story {
        margin-bottom: 100px;
        &:nth-child(odd) .story__txt {
            padding-left: 80px;
        }
    }
}
@media (min-width: 1200px) {
    .story__bg {
        position: relative;
        overflow: visible;
        height: 460px;
        &::after {
            content: "";
            position: absolute;
            top: 0;
            width: 50vw;
            height: 100%;
            background-size: contain;
        }
        &--01::after,
        &--03::after {
            left: 0;
            border-radius: var(--rounded-lg) 0 0 var(--rounded-lg);
        }
        &--02::after,
        &--04::after {
            right: 0;
            border-radius: 0 var(--rounded-lg) var(--rounded-lg) 0;
        }
        &--01::after {
            background: url("/images/sub/story/story-01.jpg");
        }
        &--02::after {
            background: url("/images/sub/story/story-02.jpg");
        }
        &--03::after {
            background: url("/images/sub/story/story-03.jpg");
        }
        &--04::after {
            background: url("/images/sub/story/story-04.jpg");
        }
    }
}
</style>
